import { TopMenuItem } from "~/models/menu";
interface MenuItemChildrenProps {
  item: TopMenuItem;
}

export function MenuItemChildren({ item }: MenuItemChildrenProps) {
  return (
    <>
      {item.children!.map((child: TopMenuItem) => (
        <a
          key={child.id}
          href={child.url}
          className="tw:px-4 tw:py-3 tw:rounded-lg tw:!no-underline tw:text-gray-900 tw:hover:!text-blue-500 tw:hover:!underline  tw:group tw:transition-colors tw:duration-100"
        >
          <div className="tw:text-base tw:font-light group-hover:tw:text-blue-600 tw:transition-colors">
            {child.title}
          </div>
        </a>
      ))}
    </>
  );
}
